import { mapActions } from 'vuex'

import { FOLLOWED_ITEM } from '@/utils/enums/personal-area'

export const followInterests = {
  computed: {
    $_followInterests_followActions() {
      return {
        [FOLLOWED_ITEM.TAGS]: {
          FOLLOW: this.requestFollowTags,
          UNFOLLOW: this.requestUnfollowTags
        },
        [FOLLOWED_ITEM.CATEGORIES]: {
          FOLLOW: this.requestFollowCategories,
          UNFOLLOW: this.requestUnfollowCategories
        },
        [FOLLOWED_ITEM.AUTHORS]: {
          FOLLOW: this.requestFollowAuthors,
          UNFOLLOW: this.requestUnfollowAuthors
        }
      }
    },
    $_followInterests_countArray() {
      return [this.FollowedAuthorCount]
    },
    $_followInterests_isFollowedCountsReceived() {
      return this.$_followInterests_countArray.every(value => value !== null)
    },
    $_followInterests_isNoFollowedItems() {
      return this.$_followInterests_countArray.every(value => value === 0)
    }
  },
  methods: {
    ...mapActions({
      requestFollowAuthors: 'profile/requestFollowAuthors',
      requestUnfollowAuthors: 'profile/requestUnfollowAuthors',
      requestFollowTags: 'profile/requestFollowTags',
      requestUnfollowTags: 'profile/requestUnfollowTags',
      requestFollowCategories: 'profile/requestFollowCategories',
      requestUnfollowCategories: 'profile/requestUnfollowCategories'
    }),
    async $_followInterests_toggleFollowingItem(itemName, id, isFollowed) {
      try {
        const Ids = Array.isArray(id) ? [...id] : [id]
        await (isFollowed
          ? this.$_followInterests_followActions[itemName].FOLLOW({
              payload: { Ids }
            })
          : this.$_followInterests_followActions[itemName].UNFOLLOW({
              payload: { Ids }
            }))
        this.$emit('refresh-profile-summary')
      } catch (e) {
        throw e
      }
    },
    async $_followInterests_toggleCategoryItem(parentCategory, isFollowed) {
      try {
        const Ids = [parentCategory.ParentCategoryId]
        await (isFollowed
          ? this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].FOLLOW({
              payload: { Ids }
            })
          : this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].UNFOLLOW({
              payload: { Ids }
            }))
        this.$emit('refresh-profile-summary')
      } catch (err) {
        throw err
      }
    }
  }
}
